import { Box } from "@mui/material"

import { MAP_EMBED_URL, OFFICE_ADDRESS } from "../constants/address"

const makeStyles = () => ({
    mapWrapper: {
        width: "100%",
        height: { xs: 260, md: 340 },
        overflow: "hidden",
        background: "#e8eef6",
    },
    iframe: {
        border: 0,
        width: "100%",
        height: "100%",
        display: "block",
        filter: "grayscale(0.15) contrast(1.05)",
    },
})

const LocationMap = () => {
    const styles = makeStyles()

    return (
        <Box sx={styles.mapWrapper}>
            <Box
                component="iframe"
                title={`Stargate Rentals location — ${OFFICE_ADDRESS}`}
                src={MAP_EMBED_URL}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                sx={styles.iframe}
            />
        </Box>
    )
}

export default LocationMap
